import "./App.css";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
import WhatToExpect from "./components/WhatToExpect";
import Promoters from "./components/Promoters";
import Opportunities from "./components/Opportunities";
import Location from "./components/Location";
import Objectives from "./components/Objectives";
import Highlights from "./components/Highlights";
import Schedule from "./components/Schedule";
import { Zones, TargetAudience } from "./components/ZonesSection";
import Speakers from "./components/Speakers";
import { Branding, ActivationZones, Sponsorships, PartnerBenefits } from "./components/PartnersSection";
import { Awards, LayoutSection, Vision } from "./components/AwardsVision";
import { Contact, Footer } from "./components/ContactFooter";
import StickyCountdown from "./components/StickyCountdown";

function HomePage() {
    return (
        <SmoothScroll>
            <div className="App relative">
                <Navigation />
                <main>
                    <Hero />
                    <About />
                    <WhatToExpect />
                    <Promoters />
                    <Opportunities />
                    <Location />
                    <Objectives />
                    <Highlights />
                    <Schedule />
                    <Zones />
                    <TargetAudience />
                    <Speakers />
                    <Branding />
                    <ActivationZones />
                    <Sponsorships />
                    <PartnerBenefits />
                    <Awards />
                    <LayoutSection />
                    <Vision />
                    <Contact />
                </main>
                <Footer />
                <StickyCountdown />
                <div className="h-20 md:h-16" aria-hidden />
            </div>
        </SmoothScroll>
    );
}

function App() {
    return (
        <>
            <Toaster position="bottom-right" theme="dark" />
            <HomePage />
        </>
    );
}

export default App;
